(function () {
  var SECTION = 'predictive-search';
  var debounceTimer = null;
  var modalOpen = false;
  var lastFocus = null;
  var abortController = null;
  var activeIndex = -1;

  function routesRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function predictiveSearchUrl() {
    var modal = document.getElementById('search-modal');
    if (modal && modal.dataset.predictiveSearchUrl) {
      return modal.dataset.predictiveSearchUrl;
    }
    return routesRoot() + 'search/suggest';
  }

  function getModal() {
    return document.getElementById('search-modal');
  }

  function getPanel() {
    var modal = getModal();
    return modal ? modal.querySelector('.search-modal-panel') : null;
  }

  function getInput() {
    return document.getElementById('predictive-search-input');
  }

  function getResultsContainer() {
    return document.querySelector('[data-predictive-search-results]');
  }

  function setExpanded(expanded) {
    var input = getInput();
    if (input) input.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function getOptions() {
    var container = getResultsContainer();
    if (!container) return [];
    return Array.prototype.slice.call(container.querySelectorAll('[role="option"]'));
  }

  function clearActive() {
    activeIndex = -1;
    var input = getInput();
    if (input) input.removeAttribute('aria-activedescendant');
    getOptions().forEach(function (opt) {
      opt.classList.remove('is-active');
      opt.setAttribute('aria-selected', 'false');
    });
  }

  function setActive(index) {
    var options = getOptions();
    if (!options.length) return;
    if (index < 0) index = options.length - 1;
    if (index >= options.length) index = 0;

    options.forEach(function (opt, i) {
      var isActive = i === index;
      if (!opt.id) opt.id = 'predictive-option-' + i;
      opt.classList.toggle('is-active', isActive);
      opt.setAttribute('aria-selected', isActive ? 'true' : 'false');
      if (isActive) {
        var input = getInput();
        if (input) input.setAttribute('aria-activedescendant', opt.id);
        if (opt.scrollIntoView) opt.scrollIntoView({ block: 'nearest' });
      }
    });
    activeIndex = index;
  }

  function openModal() {
    var modal = getModal();
    var input = getInput();
    if (!modal || !input) return;

    lastFocus = document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('search-modal-open');
    modalOpen = true;
    input.focus();

    var panel = getPanel();
    if (panel && window.DisuriA11y) {
      window.DisuriA11y.trapFocus(panel);
    }
  }

  function closeModal() {
    var modal = getModal();
    if (!modal) return;

    if (abortController) {
      abortController.abort();
      abortController = null;
    }

    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('search-modal-open');
    modalOpen = false;

    var container = getResultsContainer();
    if (container) container.innerHTML = '';
    clearActive();
    setExpanded(false);

    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }
  }

  function setLoading(isLoading) {
    var container = getResultsContainer();
    if (!container) return;
    container.classList.toggle('is-loading', isLoading);
  }

  function showError() {
    var container = getResultsContainer();
    if (!container) return;
    var message =
      container.getAttribute('data-error-message') ||
      'Search is unavailable right now. Please try again.';
    container.innerHTML = '<p class="predictive-search-error">' + message + '</p>';
  }

  function fetchResults(query) {
    var container = getResultsContainer();
    if (!container) return;

    if (abortController) {
      abortController.abort();
      abortController = null;
    }

    if (!query || query.trim().length < 2) {
      container.innerHTML = '';
      clearActive();
      setExpanded(false);
      setLoading(false);
      return;
    }

    setLoading(true);

    var params = new URLSearchParams({
      q: query.trim(),
      'resources[type]': 'product,collection,page',
      'resources[limit]': '6',
      'resources[limit_scope]': 'each',
      section_id: SECTION,
    });

    var controller = new AbortController();
    abortController = controller;

    fetch(predictiveSearchUrl() + '?' + params.toString(), { signal: controller.signal })
      .then(function (res) {
        if (!res.ok) throw new Error('Predictive search HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        container.innerHTML = html;
        clearActive();
        setExpanded(true);
        setLoading(false);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        console.error('Predictive search failed', err);
        showError();
        clearActive();
        setExpanded(true);
        setLoading(false);
      })
      .finally(function () {
        if (abortController === controller) {
          abortController = null;
        }
      });
  }

  function onInput() {
    var input = getInput();
    if (!input) return;

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      fetchResults(input.value);
    }, 280);
  }

  function onInputKeydown(e) {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setActive(activeIndex + 1);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setActive(activeIndex - 1);
    } else if (e.key === 'Enter') {
      if (activeIndex < 0) return;
      var options = getOptions();
      var active = options[activeIndex];
      if (!active) return;
      // Options are the <a> elements themselves (ARIA listbox pattern).
      var link = active.matches('a[href]') ? active : active.querySelector('a[href]');
      if (link) {
        e.preventDefault();
        link.click();
      }
    }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) {
      e.preventDefault();
      openModal();
      return;
    }

    if (e.target.closest('[data-search-close]')) {
      e.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modalOpen) {
      closeModal();
    }
  });

  var input = getInput();
  if (input) {
    input.addEventListener('input', onInput);
    input.addEventListener('keydown', onInputKeydown);
  }
})();
